import React from 'react';
import StaticBanner from '../../components/StaticBanner/index';
import OurCompanniesBanner from '../../assets/images/our-companies/our-company-main-banner.png';
import OurCompanniesBannerMobile from '../../assets/images/our-companies/our-company-main-banner-mobile.png';
import { AppContext } from '../../Context';
import { IRootState } from '../../definitions/root';
import './NotFound.css';

export default function PageNotFoundRender() {
  return (
    <AppContext.Consumer>
      {({ app: { isMobile, isTablet } }: IRootState) => {
        const OurCompaniesBannerImage = !!isMobile || !!isTablet ? OurCompanniesBannerMobile : OurCompanniesBanner;

        return (
          <div className="page page--not-found">
            <StaticBanner
              title={'Page Not Found'}
              subtitle={'Unable to find the page you are looking for.'}
              bannerImg={{
                fit: 'cover',
                src: OurCompaniesBannerImage
              }}
            />
          </div>
        );
      }}
    </AppContext.Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/containers/NotFound/render.tsx